module.exports = __webpack_public_path__ + "static/media/pre-wedding.589a33ef.mp4";